module.exports = __webpack_public_path__ + "media/entities/5002-319d2be0.png";